import {
  VIDEO_COMMENT_ADD_ERROR,
  VIDEO_COMMENT_ADD_REQUEST,
  VIDEO_COMMENT_ADD_SUCCESS,
  VIDEO_COMMENT_FETCH_ERROR,
  VIDEO_COMMENT_FETCH_REQUEST,
  VIDEO_COMMENT_FETCH_SUCCESS,
  VIDEO_COMMENT_REMOVE_FROM_STORE,
  VIDEO_COMMENT_RESET,
} from './actions';
import { removeCommentFromComments } from './utils';

const initialState = {
  total: null,
  comments: [],
  error: false,
  loading: true,
  adding: false,
  errorAdding: false,
  showSuccessMsg: false,
};

export const videoCommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIDEO_COMMENT_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        show: true,
        error: false,
      };

    case VIDEO_COMMENT_FETCH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        show: true,
        error: false,
      };

    case VIDEO_COMMENT_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        show: true,
        error: true,
      };

    case VIDEO_COMMENT_ADD_REQUEST:
      return {
        ...state,
        showSuccessMsg: false,
        adding: true,
        errorAdding: false,
      };

    case VIDEO_COMMENT_ADD_SUCCESS:
      return {
        ...state,
        showForm: false,
        show: true,
        showSuccessMsg: true,
        adding: false,
        errorAdding: false,
      };

    case VIDEO_COMMENT_ADD_ERROR:
      return {
        ...state,
        showForm: true,
        show: true,
        showSuccessMsg: false,
        adding: false,
        errorAdding: true,
      };

    case VIDEO_COMMENT_RESET:
      return initialState;

    case VIDEO_COMMENT_REMOVE_FROM_STORE:
      const comments = removeCommentFromComments(state.comments, action.payload.commentId);
      return {
        ...state,
        comments,
        showSuccessMsg: false,
        total: comments.length,
      };

    default:
      return state;
  }
};
